import { render } from "./offersComponent.vue?vue&type=template&id=36a04e4b&scoped=true"
import script from "./offersComponent.vue?vue&type=script&lang=js"
export * from "./offersComponent.vue?vue&type=script&lang=js"

import "./offersComponent.vue?vue&type=style&index=0&id=36a04e4b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a04e4b"]])

export default __exports__